export enum SortingDivisions {
    MaxFirstDevision,
    MinSecondDevision,
    MaxSecondDevision,
    MinThirdDevision,
    MaxThirdDevision,
    MinFourdDevision,
}